var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    fill: "#6A01FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 11C11.175 11 10.4688 10.7063 9.88125 10.1188C9.29375 9.53125 9 8.825 9 8C9 7.175 9.29375 6.46875 9.88125 5.88125C10.4688 5.29375 11.175 5 12 5C12.825 5 13.5312 5.29375 14.1187 5.88125C14.7062 6.46875 15 7.175 15 8C15 8.825 14.7062 9.53125 14.1187 10.1188C13.5312 10.7063 12.825 11 12 11ZM6 17V14.9C6 14.475 6.10937 14.0844 6.32812 13.7281C6.54688 13.3719 6.8375 13.1 7.2 12.9125C7.975 12.525 8.7625 12.2344 9.5625 12.0406C10.3625 11.8469 11.175 11.75 12 11.75C12.825 11.75 13.6375 11.8469 14.4375 12.0406C15.2375 12.2344 16.025 12.525 16.8 12.9125C17.1625 13.1 17.4531 13.3719 17.6719 13.7281C17.8906 14.0844 18 14.475 18 14.9V17H6ZM7.5 15.5H16.5V14.9C16.5 14.7625 16.4656 14.6375 16.3969 14.525C16.3281 14.4125 16.2375 14.325 16.125 14.2625C15.45 13.925 14.7688 13.6719 14.0813 13.5031C13.3938 13.3344 12.7 13.25 12 13.25C11.3 13.25 10.6062 13.3344 9.91875 13.5031C9.23125 13.6719 8.55 13.925 7.875 14.2625C7.7625 14.325 7.67188 14.4125 7.60313 14.525C7.53438 14.6375 7.5 14.7625 7.5 14.9V15.5ZM12 9.5C12.4125 9.5 12.7656 9.35312 13.0594 9.05937C13.3531 8.76562 13.5 8.4125 13.5 8C13.5 7.5875 13.3531 7.23438 13.0594 6.94063C12.7656 6.64688 12.4125 6.5 12 6.5C11.5875 6.5 11.2344 6.64688 10.9406 6.94063C10.6469 7.23438 10.5 7.5875 10.5 8C10.5 8.4125 10.6469 8.76562 10.9406 9.05937C11.2344 9.35312 11.5875 9.5 12 9.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgId);
export default __webpack_public_path__ + "static/media/id.12b2c588e8541638787651279850c0a1.svg";
export { ForwardRef as ReactComponent };